import * as React from "react";
import autobind from "autobind-decorator";
import {Store} from "./store";
import {observer} from "mobx-react";
import {DropWrapper, DropSection, DropLRContent} from "./components";
import {Input} from "../../form/input/index";
import {Button} from "../../button/index";
import { Query } from "./types";
import {Radio} from "../../form/radio/Radio";
import {ButtonGroup} from "../../button/group/index";
import {Checkbox} from "../../form/checkbox/index";

interface Props<T> {
  store: Store<T>;
  query: Query;
}

@observer
export class ProtableFilters<T> extends React.Component<Props<T>> {

  constructor(props: Props<T>) {
    super(props);
    this.state = {};
  }

  render() {
    const { query, store } = this.props;
    const s = store.s;
    return (
      <DropWrapper active={s.dropdown === "filters"}>

        <DropSection>
          <DropLRContent>
            <p className="font-semi-bold">Search</p>
            <Input
              value={s.search}
              onChange={(e) => store.update({ search: e.target.value })}
              placeholder="Search by name, email, phone..."
            />
          </DropLRContent>
        </DropSection>

        <DropSection>
          <DropLRContent>
            <p className="font-semi-bold">Sort By</p>
            <div className="flex-line flex-wrap child-mr-15">
              {query.sortKeys.map((sort, i) => {
                const name = `${sort.value}-sort-key`;
                return (
                  <div key={i} className="p-tb-1">
                    <Radio
                      id={name}
                      name={name}
                      checked={s.sortKey === sort.value}
                      title={sort.label}
                      value={sort.value as string}
                      onChange={() => {
                        store.update({ sortKey: sort.value as string });
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </DropLRContent>
        </DropSection>

        <DropSection>
          <DropLRContent>
            <p className="font-semi-bold">Sort Direction</p>
            <div>
              <ButtonGroup
                width={100}
                size="xs"
                selected={s.sortDirection}
                options={[
                  { value: -1, name: "Descending" },
                  { value: 1, name: "Ascending" },
                ]}
                onSelect={(v) => store.update({ sortDirection: v.value as 1 | -1 })}
              />
            </div>
          </DropLRContent>
        </DropSection>

        {query.filters.map((f, i) => (
          <DropSection key={i}>
            <DropLRContent>
              <p className="font-semi-bold">{f.label}</p>
              <div className="flex-line flex-wrap child-mr-15">
                {f.values.map((v, k) => {
                  const name = `${v.value}-filter-key-${k}`;
                  return (
                    <div key={k} className="p-tb-1">
                      <Checkbox
                        id={name}
                        name={name}
                        checked={store.filterIsActive(f.key, v.value as string)}
                        label={v.label}
                        onChange={() => store.filterToggle(f.key, v.value as string)}
                      />
                    </div>
                  );
                })}
              </div>
            </DropLRContent>
          </DropSection>
        ))}

        <DropSection>
          <Button color="primary-inverse" size="xs" onClick={store.fetch} className="m-r-2">Search</Button>
          <Button color="primary-inverse" size="xs" onClick={store.reset}>Reset</Button>
        </DropSection>

      </DropWrapper>
    );
  }

}
